export default "__VITE_ASSET__CJV$XYK8__"